export default (clientHttp) => ({
  create(params) {
    return clientHttp.post('v1/callback_requests', params)
  },
})
